import React from "react";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import NorthRoundedIcon from "@mui/icons-material/NorthRounded";
import { Box, Stack, Typography } from "@mui/material";

const iconsById = {
  moved: PersonOutlineRoundedIcon,
  actions: EmojiEventsOutlinedIcon,
  updates: ForumOutlinedIcon,
};

export default function NetworkSummaryCard({ rows }) {
  return (
    <Box
      sx={{
        px: 2,
        py: 1.85,
        borderRadius: 3,
        border: "1px solid rgba(231, 235, 244, 1)",
        bgcolor: "#fff",
        boxShadow: "0 8px 22px rgba(30, 41, 59, 0.04)",
      }}
    >
      <Typography variant="subtitle1" fontWeight={800} sx={{ color: "#1d2746", mb: 1.5 }}>
        Today at a glance
      </Typography>
      <Stack spacing={1.55}>
        {rows.map((row) => {
          const Icon = iconsById[row.id] || PersonOutlineRoundedIcon;
          return (
            <Box
              key={row.id}
              sx={{
                display: "grid",
                gridTemplateColumns: "40px 1fr",
                gap: 1.25,
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  display: "grid",
                  placeItems: "center",
                  bgcolor: row.soft,
                  color: row.accent,
                }}
              >
                <Icon sx={{ fontSize: 20 }} />
              </Box>
              <Box>
                <Box sx={{ display: "flex", alignItems: "baseline", gap: 1.05 }}>
                  <Typography variant="h5" fontWeight={800} sx={{ color: "#1d2746", lineHeight: 1, fontSize: "1.85rem" }}>
                    {row.value}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#49566c", fontWeight: 600, lineHeight: 1.25 }}>
                    {row.label}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, mt: 0.45, color: "#22b573" }}>
                  <NorthRoundedIcon sx={{ fontSize: 15 }} />
                  <Typography variant="caption" sx={{ color: "#22b573", fontWeight: 700 }}>
                    {row.change}
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}
